<template>
  <div class="contratos-page">
    <div class="page-header">
      <h2>Contratos</h2>
      <button v-if="$store.getters['auth/puede']('arriendos.contratos', 'escribir')" class="button-71 green-btn" @click="$router.push({ name: 'NuevoContrato' })">+ Nuevo Contrato</button>
    </div>
    <table class="contratos-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Propiedad</th>
          <th>Arrendatario</th>
          <th>Inicio</th>
          <th>Término</th>
          <th>Monto Mensual</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="contrato in contratos" :key="contrato.co_id">
          <td>{{ contrato.co_id }}</td>
          <td>{{ contrato.pr_id ? (propiedadesMap[contrato.pr_id] || contrato.pr_id) : '-' }}{{ contrato.pr_direccion ? ' - ' + contrato.pr_direccion : (contrato.propiedad_direccion ? ' - ' + contrato.propiedad_direccion : '') }}</td>
          <td>{{ contrato.ar_id ? (arrendatariosMap[contrato.ar_id] || contrato.ar_id) : '-' }}</td>
          <td>{{ contrato.co_fecha_inicio }}</td>
          <td>{{ contrato.co_fecha_termino }}</td>
          <td>{{ formatMontoMensual(contrato) }}</td>
          <td>
            <button class="button-71 detalle-btn blue-btn" @click="goToDetalle(contrato.co_id)">Ver Detalle</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import apiClient from '@/api/index';
export default {
  name: 'Contratos',
  data() {
    return {
      contratos: [],
      propiedadesMap: {},
      arrendatariosMap: {},
    };
  },
  async mounted() {
    try {
      const [contratosRes, propiedadesRes] = await Promise.all([
        apiClient.get('/arriendos/contratos'),
        apiClient.get('/arriendos/propiedades'),
      ]);
      const contratos = Array.isArray(contratosRes.data) ? contratosRes.data : (contratosRes.data.contratos || contratosRes.data.contrato || []);
      const propiedades = Array.isArray(propiedadesRes.data) ? propiedadesRes.data : (propiedadesRes.data.propiedades || propiedadesRes.data.propiedad || []);
      // Build lookup map for propiedades
      const propiedadesMap = {};
      for (const p of propiedades) {
        propiedadesMap[p.pr_id] = p.pr_codigo || p.codigo || '-';
      }
      // Fetch arrendatario names for all unique ar_id in contratos
      const arIds = [...new Set(contratos.map(c => c.ar_id).filter(Boolean))];
      const arrendatariosMap = {};
      await Promise.all(arIds.map(async (ar_id) => {
        try {
          const res = await apiClient.get(`/arriendos/arrendatarios/${ar_id}`);
          arrendatariosMap[ar_id] = res.data.ar_nombre || res.data.nombre || '-';
        } catch {
          arrendatariosMap[ar_id] = '-';
        }
      }));
      this.contratos = contratos;
      this.propiedadesMap = propiedadesMap;
      this.arrendatariosMap = arrendatariosMap;
    } catch (e) {
      this.contratos = [];
      this.propiedadesMap = {};
      this.arrendatariosMap = {};
    }
  },
  methods: {
    formatMontoMensual(contrato) {
      if (contrato.co_tipo === 2) {
        return 'CLP $' + Number(contrato.co_monto_clp).toLocaleString('es-CL', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      }
      return parseFloat(contrato.co_monto_uf).toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' UF';
    },
    goToDetalle(co_id) {
      this.$router.push({ name: 'ContratoDetalle', params: { contrato_id: co_id } });
    },
  },
};
</script>

<style scoped>
.contratos-page {
  padding: 2em;
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1em;
}
.button-71.green-btn {
  background-color: #22c55e !important;
  color: #fff;
  border-radius: 12px !important;
  border: none;
  padding: 0.7em 1.5em;
  font-weight: 600;
  cursor: pointer;
}
.contratos-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.98em;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.contratos-table th, .contratos-table td {
  padding: 0.7em 1em;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
}
.contratos-table th {
  background: #f0f9ff;
  font-weight: 600;
}
.contratos-table tbody tr:nth-child(even) {
  background: #f6fafd;
}
.contratos-table tbody tr:nth-child(odd) {
  background: #fff;
}
.detalle-btn {
  background: #22c55e;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.5em 1.2em;
  font-size: 1em;
  cursor: pointer;
  transition: background 0.2s;
  float: right;
}
.detalle-btn:hover {
  background: #16a34a;
}
.detalle-btn.blue-btn {
  background: #0078d4;
  color: #fff;
}
.detalle-btn.blue-btn:hover {
  background: #005fa3;
}
</style>
